module.exports = __webpack_public_path__ + "static/media/team_2.9ea43f02.png";